'use client';

import { useEffect } from 'react';
import { captureClientException } from '@instamenu/posthog/client';
import { Emoji, Text } from '@instamenu/ui-system-next';
import { Button } from '@instamenu/ui-system-next';
import { CenteredBox } from '@instamenu/ui-system-next';

export default function GlobalErrorPage({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    captureClientException(error, {
      digest: error.digest,
      source: 'route-error',
    });
  }, [error]);

  return (
    <CenteredBox style={{ height: '100dvh' }}>
      <div>
        <Emoji emoji="🤕" ariaLabel="oh-oh" />
      </div>
      <Text variant="h3">Yikes</Text>
      <Text variant="h3">Something went wrong.</Text>
      <Button onClick={() => reset()}>Try again</Button>
    </CenteredBox>
  );
}
